import { RackModule } from '@/Engine/Wardrobe/RackModule';
import { Shelf } from '@/Interfaces/common';
import { Vector3 } from 'three';
import { rackHoles } from '@/Constants/common';
import { $ } from '@/Engine/stateInstance';

export function attachRack(parentRack: RackModule, shelf: Shelf, isUp: boolean) {
    if (!shelf.rackModule) return;
    if (!shelf.rackModule.railGroup) return;
    if (shelf.rackModule.railGroup.racks.length > 1) return;
    const parentRackPosition = parentRack.position.clone();

    const direction = +(parentRack.position.x > shelf.position.x)*2-1;
    // TODO добавить поворот через кватернион
    // а может и не надо, вроде все работает
    const newPosition = new Vector3(
        parentRack.position.x - direction*(parentRack.width/2 + (isUp?0:shelf.width/2)),
        parentRackPosition.y,
        shelf.position.z,
    );

    const deltaY = parentRackPosition.y - (shelf.position.y - shelf.placeShift);
    const place = Math.round(deltaY/rackHoles);
    shelf.place = place;
    shelf.position = newPosition;
    shelf.rackModule.position = newPosition;
    const railToBeRemoved = shelf.rackModule.railGroup;
    railToBeRemoved.model.removeFromParent();
    $.toDeleteRailsUUIDs.push(railToBeRemoved.uuid);
    shelf.rackModule.railGroup = parentRack.railGroup;
    shelf.rackModule.railGroup?.update();
    $.tempShelf = shelf.raw;
    $.tempModule = shelf.rackModule.raw;
    $.tempRail = null;
}

export function detachRack(shelf: Shelf) {
    if (!shelf.rackModule) {
        console.warn('При отстыковки модуля у полки отсутствует модуль');
        return;
    }
    if (!shelf.rackModule.railGroup) {
        console.warn('При отстыковки у модуля отсутствует рельс');
        return;
    }

    // TODO условие которое не позволяло отстыковать при наличии коллизии
    // TODO не помею зачем оно было нужно, что то могло сломаться
    // if ($.checkCollision(shelf, shelf.side, [ shelf.rackModule.uuid ])) return;

    // Отстыковываем модуль
    const oldRailGroup = shelf.rackModule.railGroup;
    shelf.rackModule.railGroup = null;
    oldRailGroup.update();
    $.wardrobe.addRailForRack(shelf.rackModule.raw, [], shelf.rackModule);
    const oldPosition = shelf.position.clone();
    const oldPlaceShift = shelf.placeShift;
    oldPosition.y -= oldPlaceShift;
    shelf.place = 0;
    // shelf.rackModule.position = oldPosition;
    shelf.position = oldPosition;
}
